import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['InternalRadioProps'].map(convertArrayToTabBar);

export const RadioDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('InternalRadioProps');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <div>
      <p className="kxi-text-300 kxi-text-normal">Radio Internal Props</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'InternalRadioProps' && (
        <CodeBlock
          hasTopRadius={false}
          code={`// Use standard HTML/React props for DivProps. Applied to wrapper of radio. Ex: {style: {width: 200}}

export interface InternalRadioProps {
  wrapper?: DivProps;
}`}
        />
      )}
    </div>
  );
};
